import { datadogRum } from '@datadog/browser-rum'
import getEnv from './helpers/getEnv'
import { User } from './types/User'
import mixpanel from 'mixpanel-browser'
import Environment from './types/Environment'

const shouldTrack = () => ['production', 'staging'].includes(getEnv())

export enum AnalyticsEvent {
  //Test Event
  TestEvent = 'Test Event',
}

export enum AnalyticsEventTrigger {
  click = 'click',
  select = 'select',
  redirect = 'redirect',
  success = 'success',
  error = 'error',
  hover = 'hover',
  view = 'view',
}

interface EventArgs {
  category: AnalyticsEvent
  action: string
  label?: string
  value?: number
  nonInteraction?: boolean
  transport?: 'beacon' | 'xhr' | 'image'
}

let isUserSet = false

export default {
  init: () => {
    if (!shouldTrack()) {
      return
    }

    if (
      process.env.REACT_APP_DATADOG_RUM_APP_ID &&
      process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN &&
      process.env.REACT_APP_ENVIRONMENT &&
      process.env.REACT_APP_RELEASE_VERSION
    ) {
      datadogRum.init({
        applicationId: process.env.REACT_APP_DATADOG_RUM_APP_ID,
        clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
        service: 'kraken-frontend',
        env: process.env.REACT_APP_ENVIRONMENT,
        version: process.env.REACT_APP_RELEASE_VERSION,
        sampleRate: 100,
        premiumSampleRate: 0,
        trackInteractions: true,
      })
    }

    if (process.env.REACT_APP_MIXPANEL_APP_ID && getEnv() === Environment.Production)
      mixpanel.init(process.env.REACT_APP_MIXPANEL_APP_ID)
  },
  setUser: (user: User) => {
    if (!shouldTrack() || isUserSet) {
      return
    }
    const formattedData = user.id
      ? {
          id: user.id,
          name: user.first_name,
          email: user.email,
        }
      : user
    const userData = { ...formattedData }
    mixpanel.identify(userData.id)
    datadogRum.setUser(userData)
    isUserSet = true
  },
  event: (args: EventArgs) => {
    if (!shouldTrack()) {
      return
    }
    mixpanel.track(args.action, { ...args })
    datadogRum.addAction(args.action, { ...args })
  },
  reset: () => {
    if (!shouldTrack()) {
      return
    }
    mixpanel.reset()
  },
}
